import { clearTag, downloadTag } from "api/tags";
import { downloadExp } from "api/expression";
import { getAllDataSources, getAllTagTypeSources, getAllValueSources } from "api/dataSourceMeta";

const actionApiConfig = {
  downloadTag,
  downloadExp,
  clearTag,
  getAllDataSources,
  getAllValueSources,
  getAllTagTypeSources
};

export default actionApiConfig;